import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { Crew } from "../../api/crew";

interface CrewItemProps {
  crew: Crew;
}

const CrewItem = ({ crew }: CrewItemProps) => {
  return (
    <TableRow>
      <TableCell>{crew.id}</TableCell>
      <TableCell>{crew.companyName}</TableCell>
      <TableCell>{crew.contactPerson}</TableCell>
      <TableCell>{crew.email}</TableCell>
      <TableCell>{crew.phone}</TableCell>
      <TableCell>{crew.status}</TableCell>
      <TableCell>{crew.address}</TableCell>
      <TableCell>{crew.postcode}</TableCell>
      <TableCell>{crew.city}</TableCell>
    </TableRow>
  );
};

export default CrewItem;
